import { EmailStepSchema } from '@feedyou-ai/feedbot-schema'

import { Search } from '../../../types'
import { createConfigs, searchMutableObject } from '../../../../../features/flowSearch'

export const search: Search<EmailStepSchema> = (step, query) => {
  return searchMutableObject(
    step,
    query,
    { type: 'step', id: step.id },
    createConfigs({
      id: ['id'],
      storage: ['storageSummary.rows.%key%.storage'],
      text: [
        'condition',
        'body',
        'recipient',
        'ccRecipient',
        'bccRecipient',
        'replyTo',
        'fromName',
        'fromAddress',
        'subject',
        'bodyPrefix',
        'bodyPostfix',
        'footer',
        'logoUrl',
        'storageSummary.rows.%key%.title',
        'storageSummary.rows.%key%.storage'
      ]
    })
  )
}
